import React, { createRef } from "react";
import { render } from "react-dom";
import { ApolloProvider } from "@apollo/react-components";

import ApolloClient from "shared/util/ApolloClient";
import OnDOMReady from "shared/util/OnDOMReady";

import { getMailboxLink } from "apps/messages/util/helpers";
import Dropdown from "apps/messages/components/Dropdown";

const TARGET_ID = "messagedropdown";

const MessageDropdown = {
	init() {
		const mailbox = document.getElementById("nav_mailbox");
		this.dropdownRef = createRef();

		if (!mailbox) {
			return;
		}

		const div = document.createElement("div");
		div.id = TARGET_ID;
		mailbox.appendChild(div);

		this.listen();
	},

	listen() {
		const link = getMailboxLink();

		if (!link) {
			return;
		}

		link.addEventListener("click", (e) => {
			e.preventDefault();
			this.open();
		});
	},

	render() {
		render(
			<ApolloProvider client={ApolloClient}>
				<Dropdown ref={this.dropdownRef} />
			</ApolloProvider>,
			document.getElementById(TARGET_ID),
		);
	},

	open() {
		if (this.dropdownRef && this.dropdownRef.current) {
			this.dropdownRef.current.setIsOpen(true);
		} else {
			this.render();
		}
	},
};

OnDOMReady(() => {
	MessageDropdown.init();
});

export default MessageDropdown;



// WEBPACK FOOTER //
// ./src/features/messagedropdown/index.js